module.exports = __webpack_public_path__ + "static/media/wedding_rings.591ab227.svg";